import React, { useState } from 'react'
import "../../Styles/Careers.scss"
import innovation from "../../Assests/Careers/Innovation.svg"
import empathy from "../../Assests/Careers/Empathy.svg"
import collaboration from "../../Assests/Careers/Collaboration.svg"
import excellence from "../../Assests/Careers/Excellence.svg"
import vizzhyMemberGroup from "../../Assests/Careers/vizzhyMemberGrpPNG.png"
import JoinOurTeam from '../../Utils/JoinOurTeam'
import ReusableModal from '../../Utils/ReusableModel'

function Careers() {
    const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <div className='careers mt-4'>
      <div className='careers-vedio  pt-5 mt-5 d-flex justify-content-center align-items-center'>
        <span class="material-symbols-outlined  primary-color" style={{ fontSize: "7rem" }}>
          play_circle
        </span>
      </div>
      <div className='who-we-are-bg p-5 make-an-impact-background'>
        <div className='p-5 make-an-impact-main'>
        <div className='row w-100 fs-1 fw-bold mt-4 make-an-impact-text'>
          <div className='col-md-12 d-flex justify-content-center missionandvisiontextcolor'>Make an Impact with Vizzhy</div>
        </div>
        <div className='d-flex justify-content-center px-5 fs-4 mt-5 make-an-impact-content-main'>
          <div className='m-auto d-flex text-center make-an-impact-content'>
            Be part of a team dedicated to transforming health and wellness through innovation.
            At Vizzhy, you will work on projects that empower people and redefine healthcare.
          </div>

        </div>
        <div className='d-flex mt-4 justify-content-center'>
          <div className='d-flex primary-btn  py-3 px-5 careers-contact-us contact-us' onClick={openModal}>
            <div>Join Now</div>
            <span class="material-symbols-outlined ms-1">
              arrow_right_alt
            </span>
          </div>
        </div>
        </div>
        
      </div>

      <div className='our-core-values pt-5'>

        <div className='row w-100 fs-1 fw-bold '>
          <div className='col-md-12 d-flex justify-content-center  missionandvisiontextcolor our-core-value-text'>Our Core Values</div>
        </div>
        <div className='d-flex justify-content-center px-5 fs-4 mt-4 our-core-value-main-content'>
          <div className='w-50 m-auto d-flex text-center our-core-value-content'>
            We believe in collaboration,
            integrity, and a relentless
            pursuit of excellence to transform healthcare.
          </div>
        </div>

        <div className='row  m-auto scroll-container' style={{width:"80%"}}>
          <div className='col-md h-100'>
            <div className='card  our-core-values-card-bg p-4'>
              <div className='innovation-img'>
                <img src={innovation} class="rounded-circle bg-white p-3" alt="..." />
              </div>
              <div className='fw-bold fs-2 missionandvisiontextcolor mt-4'>Innovation</div>
              <div className='mt-2'>We thrive on creativity and forward-thinking,
                constantly pushing the boundaries of healthcare technology
                to provide the best solutions for our users.</div>
            </div>
          </div>

          <div className='col-md h-100'>
            <div className='card  our-core-values-card-bg p-4'>
              <div className='empathy-img'>
                <img src={empathy} class="rounded-circle bg-white p-3" alt="..." />
              </div>
              <div className='fw-bold fs-2 missionandvisiontextcolor mt-4'>Empathy</div>
              <div className='mt-2'>We put people first,
                understanding and addressing the unique needs of our users with compassion and care,
                ensuring every solution is user-centered.</div>
            </div>
          </div>

          <div className='col-md h-100'>
            <div className='card  our-core-values-card-bg p-4'>
              <div className='collaboration-img'>
                <img src={collaboration} class="rounded-circle bg-white p-3" alt="..." />
              </div>
              <div className='fw-bold fs-2 missionandvisiontextcolor mt-4'>Collaboration</div>
              <div className='mt-2'>We believe in the power of teamwork and collaboration,
                working together across disciplines to achieve our common goal of transforming healthcare.</div>
            </div>
          </div>

          <div className='col-md h-100'>
            <div className='card  our-core-values-card-bg p-4'>
              <div className='excellence-img'>
                <img src={excellence} class="rounded-circle bg-white p-3" alt="..." />
              </div>
              <div className='fw-bold fs-2 missionandvisiontextcolor mt-4'>Excellence</div>
              <div className='mt-2'>We hold ourselves to the highest standards,
                continuously improving and striving for excellence in everything we do to make a lasting impact in healthcare.</div>
            </div>
          </div>

        </div>




        <div className='how-to-apply mt-5'>
          <div className='d-flex justify-content-center fw-bold pt-5 missionandvisiontextcolor how-to-apply-main-text' style={{fontSize:"4rem"}}>How To Apply?</div>
          <div className='row w-100 mt-5 join-our-vizzhy-main'>
            <div className='col-md-6' >
              <div >
                <img className='join-our-vizzhy-image' src={vizzhyMemberGroup} style={{ width: "85%" }} alt='join-our-vizzhy'/>
              </div>
            </div>
            <div className='col-md-6 join-our-vizzhy-right'>
              <div className='mt-5 pt-5 p-3 join-our-vizzhy-text-main' style={{width:"95%"}}>
              <div className='fw-bold fs-1 missionandvisiontextcolor join-our-vizzhy-text'>Join Our Vizzhy Team!</div>
              <div className='fs-4 mt-4 join-our-vizzhy-content'>If you are looking for a dynamic environment where you can grow,
                innovate, and make an impact in health tech,
                we would love to have you onboard. Bring your passion,
                creativity, and ideas - we are hiring!
              </div>
              <div className='fs-4 mt-5 join-our-vizzhy-content'>
                Send your resume and portfolio to <a href='mailto:careers@vizzhy.com' className='fw-bold' style={{textDecoration:"none",color:"#9367B1"}}>careers@vizzhy.com</a>
                <div>We are excited to connect with you!</div>
              </div>
              </div>
              
            </div>
          </div>
        </div>

      </div>
      <div>
        
    
          <ReusableModal
            data="modal-xl"
           showModal={showModal}
            closeModal={closeModal}
            content={<JoinOurTeam  closeModal={closeModal}/>}
           />
         </div>
    </div>
  
  )
}

export default Careers


// import React, { useState } from 'react';
// import JoinOurTeam from '../../Utils/JoinOurTeam';
// import ReusableModal from '../../Utils/ReusableModel';

// function Team() {
//   const [showModal, setShowModal] = useState(false);

//   const openModal = () => setShowModal(true);
//   const closeModal = () => setShowModal(false);

//   return (
//     <div>
//       <button onClick={openModal}>Join Our Team</button>

//       <ReusableModal
//         data="modal-xl"
//         showModal={showModal}
//         closeModal={closeModal}
//         content={<JoinOurTeam  closeModal={closeModal}/>}
//       />
//     </div>
//   );
// }

// export default Team;
